var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main_layout_box"},[_c('Header',{staticClass:"header_box"}),_c('div',{staticClass:"content_box"},[_c('Aside',{staticClass:"aside_box"}),_c('router-view',{staticClass:"router_content"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }